import React from 'react';
import {withSystem, Atom} from '@packages/systems/wfdl';
import {TText} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const Comment = Atom.createRender(({data}) => {
  // @ts-expect-error - TS18046 - 'data' is of type 'unknown'.
  const value = data.value;
  return (
    // @ts-expect-error - TS2339 - Property 'wf-comment' does not exist on type 'JSX.IntrinsicElements'.
    <wf-comment
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={value ? {__html: `<!--${value}-->`} : null}
    />
  );
});

const config = createIntegratedAtom({
  showEmpty: false,
  render: Comment,
  fields: {
    value: withSystem({private: true}, TText),
  },
});

export default config;
